import React from "react";

import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { useIntroducingBrokerDashboardPage } from "./useIntroducingBrokerDashboardPage";
import { DashboardSlider } from "../../../../components/DashboardSlider";

import "./styles.scss";
import classNames from "classnames";
import { IntroducingBrokerMembersTable } from "components/IntroducingBrokerMembersTable";

const DASHBOARD_WIDGET_WIDTH = 325;

export const IntroducingBrokerDashboardPage: React.FC = () => {
  const { name } = useIntroducingBrokerDashboardPage();

  return (
    <div className="flex h-full flex-col">
      <div
        className={classNames(
          "flex justify-between bg-[#1F152E] pb-9 pl-5 pr-10 pt-10",
        )}
      >
        <div>
          {name && (
            <h2 className="h-10 font-['Tomato_Grotesk'] text-xl font-bold text-white">
              {name}
            </h2>
          )}
          <h1 className="mb-2 font-['Tomato_Grotesk'] text-3xl font-bold text-white">
            <FormattedMessage {...messages.welcome} />
          </h1>
        </div>
      </div>
      <div className="flex h-full flex-col gap-y-4 pl-5 pr-10">
        <DashboardSlider
          className={classNames(
            "widgets-carousel draggable h-66 half-dark-purple-background -ml-5 -mr-10",
          )}
          widgetWidth={DASHBOARD_WIDGET_WIDTH}
        ></DashboardSlider>
        <IntroducingBrokerMembersTable />
      </div>
    </div>
  );
};
